import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-opensea.svg'
import _imports_1 from '@/assets/images/icon-looksrare.svg'
import _imports_2 from '@/assets/images/icon-rarible.svg'
import _imports_3 from '@/assets/images/manifold-logograph.svg'
import _imports_4 from '@/assets/images/icon-foundation.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a16374e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "large-title"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "manifold-logo",
  src: _imports_3
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"padding":"10px"}
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]

import { BigNumber } from '@ethersproject/bignumber';
import { computed, ref } from 'vue';
import { useClaimStore } from '@/store/claimStore';

interface PlatformLinksProps {
  label?: string;
  creatorContractAddress?: string;
  tokenId?: BigNumber;
  is1155: boolean;
  hasMints: boolean;
  large?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformLinks',
  props: {
    label: null,
    creatorContractAddress: null,
    tokenId: null,
    is1155: { type: Boolean },
    hasMints: { type: Boolean },
    large: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  label?: string;
  creatorContractAddress?: string;
  tokenId?: BigNumber;
  is1155: boolean;
  hasMints: boolean;
  large?: boolean;
};

_useCssVars(_ctx => ({
  "7bdef707": (_unref(platformLinkCount))
}))

const SUPPORTED_NETWORKS = {
  FOUNDATION: [1],
  MANIFOLD: [1, 5, 10],
  RARIBLE: [1],
  LOOKSRARE: [1],
  OPENSEA: [1, 5, 10]
};



// Computer now so that the grid (see CSS below looks correct / has number of squares.)
const platformLinkCount = computed(() => {
  let count = 0;
  let companiesSupported = Object.keys(SUPPORTED_NETWORKS);

  // Manifold does not yet support collection views, so 721s are not supported links.
  if (!props.is1155) {
    companiesSupported = companiesSupported.filter((company) => {
      return company !== 'MANIFOLD';
    });
  }

  for (const company of companiesSupported) {
    if (SUPPORTED_NETWORKS[company].includes(store.networkId)) {
      count++;
    }
  }
  return count;
});

const store = useClaimStore();

const galleryBaseLink = computed(() => {
  const networkId = store.networkId;
  if (networkId === 10) {
    return 'https://gallery.manifold.xyz/optimism';
  } else if (networkId === 5) {
    return 'https://gallery.manifold.xyz/goerli';
  } else {
    return 'https://gallery.manifold.xyz';
  }
});

const openSeaBaseLink = computed(() => {
  const networkId = store.networkId;
  if (networkId === 10) {
    return 'https://opensea.io/assets/optimism';
  } else if (networkId === 5) {
    return 'https://testnets.opensea.io/assets/goerli';
  } else {
    return 'https://opensea.io/assets/ethereum';
  }
});

const tokenId1155 = computed(() => {
  const tokenId = props.tokenId;
  // TODO: is this like -1?
  if (tokenId && !(tokenId.eq(BigNumber.from('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')))) {
    return tokenId.toString();
  }
  return null;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.large)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(props.label || 'View on Platforms'), 1))
      : _createCommentVNode("", true),
    (props.hasMints || props.is1155)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 1,
          class: [__props.large ? 'large' : '', 'campaign-platform-links'],
          "data-test": "platform-links"
        }, _ctx.$attrs), [
          (!__props.large)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.label || 'View on Platforms'), 1))
            : _createCommentVNode("", true),
          (props.is1155)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(tokenId1155) && SUPPORTED_NETWORKS['OPENSEA'].includes(_unref(store).networkId))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_blank",
                      href: `${_unref(openSeaBaseLink)}/${props.creatorContractAddress}/${_unref(tokenId1155)}`
                    }, _hoisted_5, 8, _hoisted_3))
                  : (SUPPORTED_NETWORKS['OPENSEA'].includes(_unref(store).networkId))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        target: "_blank",
                        href: `${_unref(openSeaBaseLink)}/${props.creatorContractAddress}`
                      }, _hoisted_8, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                (SUPPORTED_NETWORKS['LOOKSRARE'].includes(_unref(store).networkId))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      target: "_blank",
                      href: `https://looksrare.org/collections/${props.creatorContractAddress}${_unref(tokenId1155) ? '/'.concat(_unref(tokenId1155)) : ''}`
                    }, _hoisted_11, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (SUPPORTED_NETWORKS['RARIBLE'].includes(_unref(store).networkId))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      target: "_blank",
                      href: _unref(tokenId1155) ? `https://rarible.com/token/${props.creatorContractAddress}:${_unref(tokenId1155)}` : `https://rarible.com/collection/${props.creatorContractAddress}/items`
                    }, _hoisted_14, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (_unref(tokenId1155) && SUPPORTED_NETWORKS['MANIFOLD'].includes(_unref(store).networkId))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      target: "_blank",
                      href: `${_unref(galleryBaseLink)}/${props.creatorContractAddress}/${_unref(tokenId1155)}`
                    }, _hoisted_17, 8, _hoisted_15))
                  : _createCommentVNode("", true)
              ], 64))
            : (__props.hasMints)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (SUPPORTED_NETWORKS['OPENSEA'].includes(_unref(store).networkId))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        target: "_blank",
                        href: `${_unref(openSeaBaseLink)}/${props.creatorContractAddress}`
                      }, _hoisted_20, 8, _hoisted_18))
                    : _createCommentVNode("", true),
                  (SUPPORTED_NETWORKS['RARIBLE'].includes(_unref(store).networkId))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        target: "_blank",
                        href: `https://rarible.com/collection/${props.creatorContractAddress}`
                      }, _hoisted_23, 8, _hoisted_21))
                    : _createCommentVNode("", true),
                  (SUPPORTED_NETWORKS['FOUNDATION'].includes(_unref(store).networkId))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        target: "_blank",
                        href: `https://foundation.app/collection/${props.creatorContractAddress}`
                      }, _hoisted_26, 8, _hoisted_24))
                    : _createCommentVNode("", true),
                  (SUPPORTED_NETWORKS['LOOKSRARE'].includes(_unref(store).networkId))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        target: "_blank",
                        href: `https://looksrare.org/collections/${props.creatorContractAddress}`
                      }, _hoisted_29, 8, _hoisted_27))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
        ], 16))
      : _createCommentVNode("", true)
  ], 64))
}
}

})